import {$, _, Foundation} from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'
import SidebarFilterBehavior from '../../behaviors/Behavior.SidebarFilter'

import UsersSidebarTpl from '../../templates/users/UsersSidebarTpl.html'
import {getApiHost} from "../../Sync";
import {Biscuit} from "../../utils";
import * as FileSaver from "../../../vendor/FileSaver";

// @todo If any kind of filter shall be used, add SidebarFilterBehavior
// as e.g. in OrdersSidebarView.js

export default InboomaBaseView.extend({
  
  template : UsersSidebarTpl,
  el : '#inb-c-sidebar',

  templateContext () {
    return {
      _,
      'roles' : ['admin','user','manager','booking-manager']
    }
  },

  ui : {
    flistRole : '#inb-c-left-bar-flist--roles',
    toggleStaffView : '.toggle-staff-view',
    toggleCustomersView : '.toggle-customers-view',
    //toggleLeftBarFloatBtn : '#show-left-bar',
    dropdown : '.inb-dropdown',
  },

  events : {
    //'click @ui.toggleLeftBarFloatBtn' : '_toggleLeftBar',
    'click @ui.toggleStaffView' : '_mobileToggleStaffView',
    'click @ui.toggleCustomersView' : '_mobileToggleCustomersView',
    'click .inb-toggle-sidebar-dd' : '_initDropdown',
    'click #export-xls': '_export'
  },

  behaviors : [
    {
      behaviorClass: SidebarFilterBehavior,
      unselectAllFilter : view => { 
          if (Biscuit.get('user.role') !== 'user') {
              view._userFilterSelectBox._reset();
          }
      },
      filterMap: {
          // Map for all non-select2 filter components
          /*'role' : (view, filterVal) => {
              view.collection.filterByRole(filterVal);
          }*/
      },
    }
  ],

  initialize () {
    this.render();
  },

  _mobileToggleStaffView () {
    this.getUI('toggleStaffView').addClass('hide');
    this.getUI('toggleCustomersView').removeClass('hide');
  }, 

  _mobileToggleCustomersView () {
    this.getUI('toggleStaffView').removeClass('hide');
    this.getUI('toggleCustomersView').addClass('hide');
  },

  _toggleLeftBar () {

    // unused as no filters there
    this.$el.toggleClass('open');

  },

  _initDropdown (ev) {

    ev.preventDefault();

    if (typeof this._dropdown === 'undefined') {
      this._dropdown = new Foundation.Dropdown($('#inb-c-sidebar .inb-dropdown'));
    }

    this._dropdown.open();

    return false;
  },

  _export () {
    const that =this;
    let params = '', count=0;
    _.each(this.collection.getFiltersWithValue(), (val, type) => {
      if(count > 0){
        params += '&'+type+'='+val;
      }else{
        params += '?'+type+'='+val;
      }
    });
    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + '/users/export'+params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function() {


      const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
      FileSaver.saveAs(blob, that.t("users") + " " + that.get_today() + ".xlsx");

    };

    xmlHttp.send(null);


  },

  get_today(){
    let today = new Date();

    let day = today.getDate(); // Tag

    // Monatsangabe startet bei 0!
    let month = today.getMonth()+1; // Monat

    let year = today.getFullYear(); // Jahr
    if(day < 10) {
      day = '0'+ day;
    }
    if(month < 10) {
      month = '0'+ month;
    }
    today = day + '.' + month + '.' + year;

    return today;
  },


});